import type { QueryClient } from '@tanstack/react-query';
import { reloadResources } from 'i18next';
import type { useRouter } from '@tanstack/react-router';

export async function refreshWorkspaceData(
  queryClient: QueryClient,
  router?: ReturnType<typeof useRouter>,
  options?: { invalidateAll?: boolean }
): Promise<void> {
  if (options?.invalidateAll) {
    await queryClient.invalidateQueries();
    await queryClient.refetchQueries();
  } else {
    await queryClient.invalidateQueries({
      predicate: (query) => {
        const firstKey = query.queryKey[0] as string;
        return (
          firstKey === 'authenticated-user' ||
          firstKey === 'workspaceConfigs' ||
          firstKey === 'availableRoutes' ||
          firstKey === 'workspace'
        );
      }
    });
  }
  await reloadResources();
  if (router) {
    await router.invalidate();
  }
}
